import { useFunnelData } from 'core/funnel/contexts';

export const useFlowBackgroundVideo = () => {
  const { flow } = useFunnelData();

  return flow.attributes.backgroundVideo ?? null;
};
